<template>
   <el-dialog title="请添加需识别访客的站点地址" :visible.sync="dialogVisible" width="350px" :before-close="handleClose">
    <div class="box">
      <!-- <span class="close" @click="clickClose">X</span> -->
      <!-- <p class="title">请添加需识别访客的站点地址</p> -->
      <el-form :model="form" size="small">
        <el-form-item label="站点名称" label-width="66px">
          <el-input v-model="form.siteName" placeholder="请添加站点或网页命名" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="站点地址" label-width="66px">
          <el-input v-model="form.mainUrl" placeholder="请输入网址" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <!-- <div style="text-align: center;">
        <el-button type="primary" @click="saveOrUpdateSite">确认</el-button>
        <el-button @click="dialogVisible=false">取消</el-button>
      </div> -->
    </div>
  <span slot="footer" class="dialog-footer">
    <!-- <el-button type="dialog-cancel" size="small" w88 @click="dialogVisible = false">取 消</el-button>
    <el-button type="dialog-confirm" size="small" w88 @click="dialogVisible = false">确 定</el-button> -->
      <el-button type="dialog-cancel" size="small" w88 @click="dialogVisible=false">取消</el-button>
      <el-button type="dialog-confirm" size="small" w88 @click="saveOrUpdateSite">保存</el-button>
        
  </span>

</el-dialog>
</template>

<script>
import{ saveOrUpdateSite } from '../api/newClueApi'
export default {
  data () {
    return {
      dialogVisible: false,
      form: {
        siteName: '',
        mainUrl: ''
      }
    }
  },
  methods: {
    handleOpen () {
      this.dialogVisible = true
    },
    handleClose () {
      this.dialogVisible = false
    },
    saveOrUpdateSite () {
      if (this.form.siteName == '') {
        this.$message.error('请输入站点名称')
        return
      }
      if (this.form.mainUrl == '') {
        this.$message.error('请输入站点地址')
        return
      }
      var reg = '^((https|http|ftp|rtsp|mms)?://)'
      var re = new RegExp(reg)
      if (!re.test(this.form.mainUrl)) {
        this.$message.error('请输入含http://或https://的网址')
        return
      }
      saveOrUpdateSite(this.form).then(res => {
        this.$message.success('添加成功')
        this.dialogVisible = false
        this.$emit('clickFlash', res.data.id)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .box {
    padding-top: 14px;
  // padding-right: 25px;
  // height: 255px;
  position: relative;
  margin-bottom: 14px;
  .title {
    text-align: center;
    margin-bottom: 30px;
    font-size: 15px;
    font-weight: 500;
    color: #000;
  }
}
/deep/ .el-dialog__header{
    border-bottom: none;
}
/deep/ .el-form-item__label{
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
</style>
